import { useLocation } from "react-router-dom";
import SEOHead from '@/components/base/SEOHead';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <>
      <SEOHead
        title="Seite nicht gefunden – OOPBUY Spreadsheet"
        description="Die angeforderte Seite wurde nicht gefunden. Kehren Sie zur OOPBUY Spreadsheet Startseite zurück."
        canonicalUrl={`https://oopbuyspread.biz${location.pathname}`}
        robots="noindex"
      />
      <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <h1 className="text-xl md:text-2xl font-semibold mt-6">Diese Seite wurde nicht generiert</h1>
          <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
          <p className="mt-4 text-lg md:text-xl text-gray-500">Erz&auml;hlen Sie mir mehr &uuml;ber diese Seite, damit ich sie generieren kann</p>
        </div>
      </div>
    </>
  );
}